var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._l((_vm.urls),function(href,service){return _c('b-button',{key:service,staticClass:"service mr-1",class:service,attrs:{"href":href,"target":"_blank"}},[_c('i',{staticClass:"svg",class:service}),_vm._v(" "+_vm._s(_vm.$t(`source.share.${service}`))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }